import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { UploadFatturePassiveModalComponent } from './upload-fatture-passive-modal';

export const UploadFatturePassiveModalModule: string = ng
    .module('upload-fatture-passive-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('uploadFatturePassiveModalComponent', UploadFatturePassiveModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/upload-fatture-passive-modal/upload-fatture-passive-modal.module.ts